import React, { Component } from "react";
import List from "./HomeCarePlanList";
import Edit from "./HomeCarePlanEdit";

export default class HomeCarePlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null,
      pno: "",
      name: ""
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return (
        <List
          onClick={this.handleClick}
          pno={this.state.pno}
          name={this.state.name}
        />
      );
    } else {
      return (
        <Edit
          pData={this.state.data}
          pno={this.state.pno}
          name={this.state.name}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data, pno, name) {
    this.setState({ data, mode, pno, name });
  }
}
